"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LogoffPunter_1 = require("./AAPI/calls/LogoffPunter");
const LogonPunter_1 = require("./AAPI/calls/LogonPunter");
const Unsubscribe_1 = require("./AAPI/calls/Unsubscribe");
const SetAnonymousSessionContext_1 = require("./AAPI/calls/SetAnonymousSessionContext");
const Ping_1 = require("./AAPI/calls/Ping");
const PUSHTypes_1 = require("./PUSHTypes");
const sockjs_client_1 = __importDefault(require("sockjs-client"));
const Utils_1 = require("../Shared/Utils");
class PUSHClient {
    constructor(params) {
        this._version = {
            aapiVersion: '1.0',
            implementationVersion: '15.1.0',
        };
        this._guid = Utils_1.GBETUtils.createUUID();
        this._lastPingedAt = '';
        this._pingHandle = undefined;
        this._pingInterval = 20000;
        this._pushHealthcheckHandle = undefined;
        this._lastPingRoundtripMS = 0;
        this._haveReceivedAtLeastOneStreamingMessage = false;
        this._connectionHealth = 0;
        this._connectionHealthChangeDelegates = {};
        this._anonSet = false;
        this._isConnecting = false;
        this._subscriptionRequests = {};
        this._subscriptionResponses = {};
        this._AAPIJSONResponseMappings = [];
        //Session values
        this._logonInProgress = false;
        this._loggedOn = false;
        this.socket = undefined;
        this._topicHandlers = {
            1: this._onSetAnonymousSessionContextJSON,
            2: this._onLogonPunterJSON,
            3: this._onLogoffPunterJSON,
            20: this._onUnsubscribeJSON,
            22: this._onPingJSON,
        };
        this._regexArray = [
            {
                regex: /^\S(\d{1,4})\/D\S1$/,
                method: this._onSetAnonymousSessionContext,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'maximumMessageSize',
                },
            },
            {
                regex: /^\S(\d{1,4})\/D\S2$/,
                method: this._onLogonPunter,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'debitSportsbookStake',
                    3: 'debitExchangeStake',
                    4: 'purseIntegrationMode',
                    5: 'canPlaceForSideOrders',
                    6: 'canPlaceAgainstSideOrders',
                    7: 'restrictedToFillKillOrders',
                    8: 'currency',
                    9: 'language',
                    10: 'priceFormat',
                    11: 'marketByVolumeAmount',
                    12: 'isRetailPunter',
                    13: 'aapiSessionToken',
                    14: 'maximumMessageSize',
                },
            },
            { regex: /(\d{1,4})\/D\S3.*$/, method: this._onLogoffPunter },
            { regex: /(\d{1,4})\/D\S20.*$/, method: this._onUnsubscribe },
            { regex: /(\d{1,4})\/D\S22.*$/, method: this._onPing },
        ];
        this.ping = Ping_1.ping.bind(this);
        this.setAnonymousSessionContext = SetAnonymousSessionContext_1.setAnonymousSessionContext.bind(this);
        this.logonPunter = LogonPunter_1.logonPunter.bind(this);
        this.logoffPunter = LogoffPunter_1.logoffPunter.bind(this);
        this.unsubscribe = Unsubscribe_1.unsubscribe.bind(this);
        this._correlationData = {};
        this._pushMessages = {};
        this._correlationDataId = -1;
        this.initializationParams = params;
        if (params.version)
            this._version = params.version;
    }
    static get now() {
        return new Date().toISOString();
    }
    async connect() {
        this.socket = new sockjs_client_1.default(this.initializationParams.url, null, this.initializationParams.sockOptions);
        return new Promise((resolve) => {
            this.connectService(this.initializationParams.url, (params) => {
                console.log('afterconnect', params);
                resolve('complete');
                this.initializationParams.onStatusChange('connected');
            });
        });
    }
    initialize() {
        this.connectService(this.initializationParams.url, (params) => {
            console.log('afterconnect', params);
            this.initializationParams.onStatusChange('connected');
        });
    }
    _onPing({ bodyObject }) {
        return this._onPingJSON(bodyObject);
    }
    _onPingJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        this.removeFromPushMessages(correlationId);
        const correlationData = this._correlationData[correlationId];
        if (returnCode !== 0) {
            console.error('_onPing', bodyObject);
        }
        const request = this._correlationData[correlationId];
        // messagesInQueue = bodyObject[2];
        const curTime = new Date();
        const lastTime = new Date(request.currentClientTime);
        this._lastPingedAt = lastTime.toISOString();
        this._lastPingRoundtripMS = curTime.getTime() - lastTime.getTime();
        this._connectionHealth = this._lastPingRoundtripMS;
        for (const i in this._connectionHealthChangeDelegates) {
            if (this._connectionHealthChangeDelegates[i] !== undefined) {
                this._connectionHealthChangeDelegates[i](this._connectionHealth);
            }
        }
        if (returnCode === 0) {
            correlationData?.callbackOnSuccess({
            //  correlationId: correlationId,
            });
        }
        else {
            correlationData?.callbackOnException(new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onSetAnonymousSessionContext({ bodyObject }) {
        this._onSetAnonymousSessionContextJSON(bodyObject);
    }
    _onSetAnonymousSessionContextJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        const correlationData = this._correlationData[correlationId];
        if (returnCode === 0) {
            correlationData?.callbackOnSuccess.call(this, {});
        }
        else {
            correlationData?.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onUnsubscribe({ bodyObject }) {
        this._onUnsubscribeJSON(bodyObject);
    }
    _onUnsubscribeJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        this.removeFromPushMessages(correlationId);
        const correlationData = this._correlationData[correlationId];
        if (returnCode === 0) {
            const subIds = this._correlationData[correlationId]
                .subscriptionIds;
            if (subIds !== undefined) {
                for (let i = 0; i < subIds.length; i++) {
                    const subId = subIds[i];
                    if (this._subscriptionResponses[subId]) {
                        const corId = this._subscriptionResponses[subId]
                            .correlationId;
                        delete this._subscriptionResponses[subId];
                        delete this._correlationData[corId];
                    }
                }
            }
            correlationData?.callbackOnSuccess.call(this, { something: 'here' });
        }
        else {
            correlationData?.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    async checkConnection(seconds) {
        const waitTime = seconds * 1000;
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(async function () {
                reject();
            }, waitTime);
            const curTime = new Date().toISOString();
            if (this._lastPingedAt === '') {
                this._lastPingedAt = curTime;
            }
            this.ping({
                currentClientTime: curTime,
                lastPingRoundtripMS: this._lastPingRoundtripMS,
                lastPingedAt: this._lastPingedAt,
            })
                .then(() => {
                console.log('successful ping');
                clearTimeout(timeoutId);
                resolve('connected');
            })
                .catch(() => {
                console.error('failed ping');
                clearTimeout(timeoutId);
                reject();
            });
        });
    }
    _onLogonPunter({ bodyObject }) {
        this._onLogonPunterJSON(bodyObject);
    }
    _onLogonPunterJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        this.removeFromPushMessages(correlationId);
        this._anonSet = false;
        const correlationData = this._correlationData[correlationId];
        if (returnCode !== 0) {
            correlationData?.callbackOnException?.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
        else {
            this.userContextAAPI = {
                debitSportsbookStake: bodyObject.debitSportsbookStake,
                debitExchangeStake: bodyObject.debitExchangeStake,
                purseIntegrationMode: Number(bodyObject.purseIntegrationMode),
                canPlaceForSideOrders: bodyObject.canPlaceForSideOrders,
                canPlaceAgainstSideOrders: bodyObject.canPlaceAgainstSideOrders,
                restrictedToFillKillOrders: bodyObject.restrictedToFillKillOrders,
                currency: bodyObject.currency,
                language: bodyObject.language,
                priceFormat: Number(bodyObject.priceFormat),
                marketByVolumeAmount: Number(bodyObject.marketByVolumeAmount),
                isRetailPunter: bodyObject.isRetailPunter,
                maximumMessageSize: bodyObject.maximumMessageSize,
            };
            this._aapiSessionToken = bodyObject.aapiSessionToken;
            this._logonInProgress = false;
            this._loggedOn = true;
            correlationData.callbackOnSuccess.call(this, {
                userContext: this.userContextAAPI,
            });
        }
    }
    _onLogoffPunter({ bodyObject }) {
        this._onLogoffPunterJSON(bodyObject);
    }
    _onLogoffPunterJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        this.removeFromPushMessages(correlationId);
        this._aapiSessionToken = undefined;
        const correlationData = this._correlationData[correlationId];
        if (returnCode !== 0) {
            correlationData?.callbackOnException(new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
        else {
            correlationData?.callbackOnSuccess({});
        }
    }
    extendRegex(arr) {
        this._regexArray = this._regexArray.concat(arr);
    }
    extendTopicHandlers(topicHandlers) {
        this._topicHandlers = { ...this._topicHandlers, ...topicHandlers };
    }
    addToCorrelation(params) {
        this._correlationData[++this._correlationDataId] = params;
        const correlationDataId = this._correlationDataId;
        const promise = new Promise((resolve, reject) => {
            params['callbackOnSuccess'] = function (response) {
                resolve(response);
            };
            params['callbackOnException'] = function (response) {
                reject(response);
            };
        });
        return { correlationDataId, promise };
    }
    pushHealthcheckEnabled() {
        return true;
    }
    // Add the message to object (keyed by the correlationId) to check that we have received a response.
    // On the callback we will remove this message. The object will be checked periodically and
    // if there are old messages i.e. messages we haven't received a response for, we will
    // initiate a reconnect
    addToPushMessages(params) {
        //const correlationId: number = params[0];
        if (this.pushHealthcheckEnabled()) {
            // Start the timer if it doesn't already exist
            if (!this._pushHealthcheckHandle) {
                this.clearPushMessages();
                //PUSHClient._pushHealthcheckHandle = window.setInterval(function () {
                //    PUSHClient.checkPushMessages();
                //}, PUSHClient.pushHealthcheckInterval());
                /*if (PUSHClient.userContext && gecPrivate.userContext.partnerUsername) {
                            PUSHClient.clientLogger.logClientEntry({
                                clientLogEntryType: 3,
                                componentName: "application",
                                subcomponentName: "push",
                                logEntry: "SOCK: Starting healthcheck for punter: " + gecPrivate.userContext.partnerUsername
                            });
                        }*/
            }
            this._pushMessages[params[0]] = {
                sentTime: Date.now(),
                request: params,
            };
        }
        //return this. correlationId
    }
    removeFromPushMessages(correlationId) {
        // Remove the message from the list once ou have received a response
        delete this._pushMessages[correlationId];
    }
    clearPushMessages() {
        this._pushMessages = {};
    }
    stopPushHealthcheckTimer() {
        if (this._pushHealthcheckHandle !== undefined) {
            window.clearInterval(this._pushHealthcheckHandle);
            this._pushHealthcheckHandle = undefined;
        }
        this.clearPushMessages();
    }
    _sendStreamingMessage(headerName, request) {
        const message = this._createTopicMessageStr(request);
        const promise = this.addToPushMessages(request);
        this.socket.send('\u0002' + headerName + '\u0001' + message);
        return promise;
    }
    _sendStreamingMessageJSON(request) {
        this.socket.send(JSON.stringify(request));
    }
    convertParamToBoolString(item) {
        return item ? 'T' : 'F';
    }
    _createTopicMessageStr(tm) {
        let message = '';
        for (const itemI in tm) {
            if (tm[itemI] !== undefined) {
                const value = typeof tm[itemI] === 'boolean'
                    ? this.convertParamToBoolString(tm[itemI])
                    : tm[itemI];
                message += itemI + '\u0002' + value + '\u0002\u0001';
            }
        }
        return message;
    }
    close() {
        this.socket.close();
    }
    sendSubscriptionMessage(code, request, correlationDataId) {
        this._subscriptionRequests[correlationDataId] = () => {
            this._sendStreamingMessage(code, request);
        };
        this._subscriptionRequests[correlationDataId]();
    }
    sendSubscriptionMessageJSON(request) {
        const correlationId = request.correlationId;
        this._subscriptionRequests[correlationId] = () => {
            this.socket.send(JSON.stringify(request));
        };
        this._subscriptionRequests[correlationId]();
    }
    resubscribe() {
        for (const s in this._subscriptionRequests) {
            this._subscriptionRequests[s]();
        }
    }
    connectService(url, onComplete) {
        //declared at this scope as needed again for reconnect function
        //const instance = this;
        const _onDataEventJSON = (messageJSON) => {
            const message = JSON.parse(messageJSON);
            if (this.initializationParams.onData) {
                this.initializationParams.onData(message);
            }
            const _regexArray = this._regexArray;
            if (this._topicHandlers[message.aapiId]) {
                this._topicHandlers[message.aapiId].call(this, message);
            }
            else if (message.header !== undefined) {
                _regexArray.forEach((mapping) => {
                    const matches = message.header.topicName.match(mapping.regex);
                    if (matches !== null) {
                        const response = {
                            webClientMessage: message.header,
                            headerMatches: null,
                            bodyObject: message.body,
                        };
                        mapping.method.call(this, response);
                        return;
                    }
                });
            }
        };
        const _onDataEvent = (webClientMessage) => {
            const header = webClientMessage.getHeader();
            const topic = webClientMessage.topic;
            const _regexArray = this._regexArray;
            for (let i = 0; i < _regexArray.length; i++) {
                let headerMatches = _regexArray[i].regex.exec(topic); // /r?or?/g
                if (headerMatches === null)
                    headerMatches = _regexArray[i].regex.exec(header);
                if (headerMatches !== null) {
                    const bodyObject = {};
                    const numberOfFields = webClientMessage.getNumberOfRecords();
                    for (let f = 0; f < numberOfFields; f++) {
                        const rowData = webClientMessage.getFields(f);
                        if (_regexArray[i].converter === undefined) {
                            if (rowData[0] === '0') {
                                bodyObject.correlationId = Number(rowData[1]);
                            }
                            else if (rowData[0] === '1') {
                                bodyObject.returnCode = Number(rowData[1]);
                            }
                        }
                        else {
                            const cvtr = _regexArray[i].converter;
                            if (cvtr !== undefined) {
                                _convertBodyItem(bodyObject, rowData[0], rowData[1], cvtr);
                            }
                        }
                    }
                    if (bodyObject.returnCode !== undefined) {
                        bodyObject.returnCode = Number(bodyObject.returnCode);
                    }
                    if (bodyObject.correlationId !== undefined) {
                        bodyObject.correlationId = Number(bodyObject.correlationId);
                    }
                    if (bodyObject.subscriptionId !== undefined) {
                        const subscriptionId = (bodyObject.subscriptionId = Number(bodyObject.subscriptionId));
                        this._subscriptionResponses[subscriptionId] = {
                            correlationId: bodyObject.correlationId,
                        };
                    }
                    //console.log(_regexArray[i].method.name, bodyObject);
                    if (this.initializationParams.onData) {
                        this.initializationParams.onData(bodyObject);
                    }
                    return _regexArray[i].method.call(this, {
                        webClientMessage,
                        headerMatches,
                        bodyObject,
                    });
                }
            }
            console.error('unknown message topic:' + webClientMessage.topic);
        };
        const _convertBodyItem = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        newObject, name, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value, converter) => {
            if (name === '')
                return newObject;
            //console.log(value, converter);
            const names = name.split('-');
            if (names.length > 1 && converter) {
                const namePrefix = Number(names[0].split('V')[0]);
                const index = Number(names[0].split('V')[1]) - 1;
                const remainingName = name.substring(name.indexOf('-') + 1);
                if (converter[namePrefix] === undefined) {
                    converter = converter[0];
                }
                if (newObject[namePrefix] === undefined) {
                    newObject[namePrefix] = {};
                }
                if (newObject[namePrefix][index] === undefined) {
                    newObject[namePrefix][index] = {};
                }
                return _convertBodyItem(newObject[namePrefix][index], remainingName, value, converter[namePrefix]);
            }
            else {
                if (value == 'T')
                    value = true;
                if (value == 'F')
                    value = false;
                const tempName = Number(name);
                converter = converter || {};
                if (converter[tempName] === undefined) {
                    converter = converter[0];
                    //newObject[tempName] = value;
                }
                const key = converter[tempName];
                newObject[key] = value;
            }
            return newObject;
        };
        this.socket.onmessage = (e) => {
            this._haveReceivedAtLeastOneStreamingMessage = true;
            if (e.data[0] === '{') {
                _onDataEventJSON(e.data);
            }
            else {
                const webClientMessage = new PUSHTypes_1.PUSHClientMessage(e.data);
                _onDataEvent(webClientMessage);
            }
        };
        this.socket.onopen = () => {
            _onSocketOpen(true);
            onComplete(true);
            this.initializationParams.onStatusChange('open');
        };
        const _onSocketOpen = (isConnected) => {
            window.clearInterval(this._pingHandle);
            this.stopPushHealthcheckTimer();
            if (isConnected) {
                this._isConnecting = false;
                this._pingHandle = window.setInterval(() => {
                    if (!this._anonSet && this._aapiSessionToken === undefined)
                        return;
                    const curTime = new Date().toISOString();
                    if (this._lastPingedAt === '') {
                        this._lastPingedAt = curTime;
                    }
                    this.ping({
                        currentClientTime: curTime,
                        lastPingRoundtripMS: this._lastPingRoundtripMS,
                        lastPingedAt: this._lastPingedAt,
                    });
                }, this._pingInterval);
            }
        };
        this.socket.onerror = (error) => {
            console.error(error);
            this.initializationParams.onStatusChange('error');
        };
        this.socket.onclose = () => {
            this.initializationParams.onStatusChange('close');
        };
    }
}
exports.default = PUSHClient;
